<!--  -->
<template>
  <div class='bodyMain'>
    <div class="">  
      <div class="maxWidth">
        <div class="flexView tabParent">
          <div v-for="item in tabList" class="tabs canClick" @click="status = item.value" :key="item.value">
            <div :class="{redFont: item.value == status}">{{item.label}}</div>
            <div :class="{redBtm: item.value == status}"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="addProduct" v-if="canAdd" @click="addGoods">添加商品</div>
    <div class="listBody maxWidth">
      <div v-for="item in list" :key="item.id" class="goodsDetail">
        <div class="flexView">
          <div>
            <div class="title" :title="item.productName">{{item.productName || '暂无商品名称'}}</div>
            <div class="goodsMessage">
              <div class="goodsImg">
                <el-image :src="item.productPic || require('@/assets/zanwu.png')" alt="" :preview-src-list="[item.productPic]"></el-image>
                <!-- <img v-if="item.isNew" class="isNew" src="@/assets/isNew.png" alt=""> -->
              </div>
              <div class="flexMsg">
                <div>
                  <span>品牌名称：</span>
                  <span>{{item.brandName}}</span>
                </div>
                <div>
                  <span>产品规格：</span>
                  <span>{{item.productSpecs}}</span>
                </div>
              </div>
              <div class="flexMsg">
                <div>
                  <span>代发价：</span>
                  <span>{{item.daiFaPrice}}</span>
                </div>
                <div>
                  <span>到仓价：</span>
                  <span>{{item.daoCangPrice}}</span>
                </div>
              </div>
              <div class="flexMsg">
                <div>
                  <span>最低活动售价：</span>
                  <span>{{item.zuiDiPrice}}</span>
                </div>
                <div>
                  <span>现货数量：</span>
                  <span>{{item.count}}</span>
                </div>
              </div>
              <div class="flexMsg">
                <div>
                  <span>日产能：</span>
                  <span>{{item.capacityDay}}</span>
                </div>
                <div>
                  <span>类别：</span>
                  <span>{{item.categoryName}}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.zizhiPic" class="rightMsg">
            <el-image :src="item.zizhiPic" alt="" :preview-src-list="[item.zizhiPic]"></el-image>
          </div>
          <div class="rightMsg">
            <div style="height: 32px">
              <el-button size="small" v-if="item.status == 1 || item.status == 4" @click.stop="delGoods(item)">删除</el-button>
              <el-button size="small" type="primary" @click.stop="openPage('goodsEdit', item)">详情</el-button>
            </div>
            <div>状态</div>
            <div :class="item.status == 4 ? 'red' : 'green'">
              <i v-if="item.status == 4" class="el-icon-error"></i>
              <i v-else-if="item.status == 3" class="el-icon-success"></i>
              <span>{{item.statusDes}}</span>
            </div>
          </div>
        </div>
        <div class="bolder"></div>
      </div>
      <div style="padding: 10px 0 20px">
        <BasePagination :now.sync="page" :pageSize="limit" :total="total" />
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination";
export default {
  props: ['canAdd'],
  components: {
    BasePagination
  },
  data() {
    return {
      status: 0,
      total: 0,
      limit: 5,
      page: 1,
      list: [],
      tabList: [
        { label: '全部', value: 0 },
        { label: '待提交', value: 1 },
        { label: '待审核', value: 2 },
        { label: '已审核', value: 3 },
      ]
    }
  },
  computed: {
    keywords() {
      return this.$store.state.keywords
    }
  },
  watch: {
    keywords() {
      this.filterData()
    },
    status() {
      this.filterData()
    },
    page() {
      this.getData()
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getData()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  
  },
  methods: {
    getData() {
      this.$http.get('/api/WebProduct/QueryProducts', {
        params: {
          PageSize: this.limit,
          PageIndex: this.page,
          Keyword: this.keywords,
          Status: this.status
        }
      }).then(res => {
        this.list = res.data.items
        this.total = res.data.totalCount
      })
    },
    openPage(url, item) {
      this.$router.push({
        name: url,
        query: {
          id: item.id,
        }
      })
    },
    addGoods() {
      this.$router.push({name: 'goodsEdit'})
    },
    filterData() {
      this.page === 1 ? this.getData() : this.page = 1
    },
    delGoods(item) {
      this.$confirm(`确定要删除${item.productName || '此商品'}吗?`, '提示').then(() => {
        this.$http.post('/api/WebProduct/DeleteProduct', {
          id: item.id
        }).then(() => {
          this.getData()
        }).catch(() => {})

      })
    }
  },
}
</script>
<style lang='scss'>
.bodyMain {
  .tabParent {
    width: 500px;
    align-items: flex-start;
  }

  .addProduct {
    position: fixed;
    background: #409EFF;
    width: 40px;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    right: 40px;
    top: 50vh;
    color: #fff;
    cursor: pointer;
  }
  > div {
    background: #fff;
    margin: 0 auto;
  }
  .tabs {
    width: 80px;
    margin-right: 60px;
    text-align: center;
    font-size: 16px;
    color: #666;
    > :first-child {
      margin: 10px 0;
    }
    > :last-child {
      height: 2px;
    }
  }
  .listBody {
    background: #fff;
    margin: 14px auto;
    border-radius: 2px;
    .title {
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: bold;
      max-width: 1000px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .goodsDetail {
      padding: 16px 32px 0;
      .goodsMessage {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;
        > .flexMsg {
          height: 50px;
          width: 250px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
      }
      
      .goodsImg {
        width: 66px;
        height: 66px;
        margin-right: 24px;
        border-radius: 4px;
        position: relative;
        > :first-child {
          width: 66px;
          height: 66px;
          border-radius: 4px;
        }
        > .isNew {
          position: absolute;
          width: 40px;
          height: 40px;
          top: -3px;
          left: -3px;
        }
      }
      .rightMsg {
        flex: 1;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: right;
        img {
          width: 100px;
          height: 100px;
        }
        > :nth-child(2) {
          font-size: 14px;
        }
        > :nth-child(3) {
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          i {
            margin-right: 10px;
            font-size: 24px;
          }
        }
        .green {
          color: #52C41A;
        }
        .red {
          color: #D54B53;
        }
      }
      .bolder {
        margin-top: 14px;
        border-bottom: 1px solid #E8E8E8;
      }
    }
  }

  .redFont {
    font-weight: bold;
    color: #D54B53;
  }
  .redBtm {
    height: 2px;
    width: 60px;
    margin: 0 auto;
    background: #D54B53;
  }

  .grayBg {
    filter: grayscale(100%);
  }
}
</style>